/* Reuse the original form, variant, properties, quantity, inventory and drawer. */
(() => {
  if (window.chCommerceReady) return;
  window.chCommerceReady = true;
  let target = null, frame = 0, nativeBusyObserver;
  const bar = document.createElement('div');
  bar.className = 'ch-sticky-atc'; bar.hidden = true;
  bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Sieraad toevoegen');
  bar.innerHTML = '<div class="ch-sticky-atc__info"><img class="ch-sticky-atc__image" alt="" width="48" height="48"><div><span class="ch-sticky-atc__title"></span><span class="ch-sticky-atc__price"></span></div></div><button type="button" class="button ch-sticky-atc__button"></button>';
  const space = document.createElement('div'); space.className = 'ch-sticky-space';
  document.body.append(space, bar);
  const button = bar.querySelector('button');
  const title = bar.querySelector('.ch-sticky-atc__title');
  const price = bar.querySelector('.ch-sticky-atc__price');
  const image = bar.querySelector('img');
  function selectTarget() {
    const main = document.querySelector('#MainContent');
    const form = main?.querySelector('product-info product-form form[data-type="add-to-cart-form"]');
    const submit = form?.querySelector('[name="add"]');
    const reference = main?.querySelector('.lb-detail-info > .button:not(.lb-customize)');
    const source = submit || reference;
    if (source === target?.source) return;
    nativeBusyObserver?.disconnect();
    target = source ? {source, form: submit ? form : null} : null;
    if (target) {
      nativeBusyObserver = new MutationObserver(schedule);
      nativeBusyObserver.observe(source, {attributes:true, childList:true, subtree:true});
    }
    update();
  }
  function update() {
    frame = 0;
    if (!target) { bar.hidden = true; space.classList.remove('is-visible'); return; }
    if (!target.source.isConnected) { selectTarget(); return; }
    const source = target.source;
    const hiddenByDialog = document.querySelector('cart-drawer.active,dialog[open],.menu-drawer-container[open]');
    const isPast = source.getClientRects().length > 0 && source.getBoundingClientRect().bottom <= 0;
    const visible = isPast && !hiddenByDialog;
    bar.hidden = !visible; space.classList.toggle('is-visible', visible);
    if (!visible) return;
    const scope = source.closest('product-info') || source.closest('.lb-product-screen');
    title.textContent = scope?.querySelector('h1')?.textContent.trim() || '';
    price.textContent = (scope?.querySelector('.price--on-sale .price-item--sale') || scope?.querySelector('.price .price-item--regular') || scope?.querySelector('.lb-card__price > span') || scope?.querySelector('.lb-card__price'))?.textContent.trim() || '';
    const im = scope?.querySelector('.product__media img,.lb-detail-image img');
    image.hidden = !im; if (im && image.src !== im.currentSrc) image.src = im.currentSrc || im.src;
    const busy = source.classList.contains('loading') || source.getAttribute('aria-disabled') === 'true';
    button.disabled = !!source.disabled || busy;
    button.textContent = source.querySelector('span:not(.svg-wrapper)')?.textContent.trim() || source.textContent.trim();
    button.setAttribute('aria-busy', String(busy));
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  button.addEventListener('click', () => {
    if (!target || button.disabled) return;
    const {source, form} = target;
    if (source.disabled || source.getAttribute('aria-disabled') === 'true') return;
    if (form) form.requestSubmit(source); else source.click();
    schedule();
  });
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  window.addEventListener('hashchange', () => setTimeout(selectTarget, 0));
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', selectTarget);
  new MutationObserver(() => { selectTarget(); schedule(); }).observe(document.querySelector('#MainContent') || document.body, {childList:true,subtree:true});
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, {attributes:true,attributeFilter:['class']});
  selectTarget();
})();
